import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FilterDropdown from 'components/Layout/FilterDropdown';
import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import { limit } from 'utils/constants';
import {
  getDataFromLocalStorage,
  getEventDate,
  getUserType,
  objectToFormData,
} from 'utils/helpers';
import { fetchNewAllEvents } from 'store/slices';
import SeachInput from 'components/form/SeachInput';
import usePermission from 'hooks/usePermission';


const CertificateManagement = () => {
  const params = useParams();
  const { type } = params;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { viewAccess } = usePermission("Requests");

  const { eventTypeList } = useSelector((state) => ({
    eventTypeList: state.global.eventTypeList,
  }));
  const memberType = getUserType();
  const userType = getDataFromLocalStorage('user_type');
  const [searchText, setSearchText] = useState('');
  const [timer, setTimer] = useState('');

  const urlType = ['0', '1'].includes(userType)
    ? 'request-received'
    : 'raised-request';

  const [isLoading, setIsLoading] = useState(true);
  const [tableList, setTableList] = useState([]);
  const [searchPayload, setSearchPayload] = useState({
    event_name: '',
    event_type: '',
    membership_id_or_type: '',
  });
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
    event_by_filter: '',
  });

  const getEvents = async (obj) => {
    const updatedObj = { ...obj, details_type: 'participants_requests' };
    let forData = objectToFormData(updatedObj);
    const response = await dispatch(fetchNewAllEvents(forData));
    // const response = await dispatch(fetchAllEvents(forData));
    setTableList(response?.data?.events || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };
  const handelChangeFilter = (val) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, event_by_filter: val, offset: 0 };
    setFilterData(newData);
    getEvents(newData);
  };
  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getEvents(newData);
  };

  const handelChangePagination = (offset, newLimit) => {
    setIsLoading(true);
    const updatedData = {
      ...filterData,
      ...searchPayload,
      offset,
      limit: newLimit ?? filterData.limit,
    };
    setFilterData(updatedData);
    getEvents(updatedData);
  };

  // Debounced search handler
  const handleSearch = (e) => {
    let value = e?.target?.value;
    setSearchText(value);
    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      const updatedSearchPayload = { ...searchPayload, global_filter: value };
      setSearchPayload(updatedSearchPayload);
      const updatedFilterData = {
        ...filterData,
        offset: 0,
        ...updatedSearchPayload,
      };
      setIsLoading(true);
      setFilterData(updatedFilterData);
      getEvents(updatedFilterData);
    }, 800);
    setTimer(time);
  };


  useEffect(() => {
    let newFilterData = filterData;
    let newSearchPayload = searchPayload;
    if (localStorage.filterData) {
      newFilterData = JSON.parse(localStorage.filterData);
      setSearchPayload(newFilterData);
      localStorage.removeItem('filterData');
    }
    if (localStorage.searchPayload) {
      newSearchPayload = JSON.parse(localStorage.searchPayload);
      setFilterData(newSearchPayload);
      localStorage.removeItem('searchPayload');
    }

    getEvents({ ...newFilterData, ...newSearchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRedirect = (url) => {
    navigate(url);
  };

  const header = [
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: { options: eventTypeList, key: 'id', value: 'name' },
      searchInputName: 'event_type',
      title: 'Event Type',
    },
    {
      isSearch: true,
      searchInputName: 'event_name',
      title: 'Event Name',
    },
    {
      isSearch: true,
      isDatePicker: true,
      searchInputName: 'date',
      title: 'Date & Venue',
    },
    {
      isSearch: true,
      searchInputName: true,
      searchInputName: 'status',
      title: 'Status',
    },
  ];

  const rowData = [];
  tableList.forEach((elem) => {
    let obj = [
      {
        value: elem.event_type,
      },
      {
        value: (
          <div
            className="pointer color-new-car"
            // onClick={() => {
            //   localStorage.filterData = JSON.stringify(filterData);
            //   localStorage.searchPayload = JSON.stringify(searchPayload);
            //   {
            //     viewAccess === '1' &&
            //       handleRedirect(
            //         `/${memberType}/${urlType}/${type}/request/${elem.id}`
            //       );
            //   }
            // }}
            onClick={() => {
              viewAccess === '1' &&
                handleRedirect(
                  `/${memberType}/${urlType}/${type}/request/${elem.id}`
                )
            }
            }
          >
            {elem.event_name}
          </div>
        ),
      },
      {
        value: (
          <span>
            <div>{getEventDate(elem.start_date, elem.end_date)}</div>
            {elem?.country_name && (
              <div>{`${elem?.city_name ? `${elem?.city_name},` : ''} ${elem?.country_name
                }`}</div>
            )}
          </span>
        ),
      },
      {
        value: elem.status,
      },
    ];

    rowData.push({ data: obj });
  });

  return (
    <Card className="cps-20 cpe-20 cpb-20">
      <div className="d-flex justify-content-between align-items-center cpt-28 cpb-28">
        <div className="table-title">All Events ({filterData?.total})</div>
        <div style={{ width: '150px' }} className="me-3">
          <SeachInput
            placeholder="Search"
            value={searchText}
            onChange={handleSearch}
            className="small-text-input"
            iconClassName="small-search-icon"
          />
        </div>
      </div>
      <Table
        isLoading={isLoading}
        header={header}
        rowData={rowData}
        filterData={filterData}
        searchPayload={searchPayload}
        searchInputChange={handelChangeSearch}
        changeOffset={handelChangePagination}
        maxHeight="60vh"
        showRowsLimit={['0', '1'].includes(userType)}
      />
    </Card>
  );
};

export default CertificateManagement;
